import React from 'react'
import UpdatePopupForm from '../../component/form/popup/UpdatePopupForm'

export default function UpdatePopup() {
    return (
        <>
         <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className='layout_head'>
                            <h5>Update Popup</h5>
                            <UpdatePopupForm />
                        </div>
                     
                    </div>
                </div>
            </div>
        </>
    )
}
